import React from "react";
import Button from "@material-ui/core/Button";
import { FastField, Field } from "formik";
import { AddPropertyFieldComponent } from "../property/PropertyField";

const SubmitButton = ({
  children,
  label,
  fast = true,
  FieldComponent = fast ? FastField : Field,
  ...props
}) => (
  <FieldComponent>
    {({ form: { isSubmitting, isValidating, isValid, dirty, errors } }) => (
      <Button
        type="submit"
        disabled={
          isSubmitting ||
          isValidating ||
          !isValid ||
          (!dirty && errors && Object.keys(errors).length > 0)
        }
        {...props}
      >
        {children || label}
      </Button>
    )}
  </FieldComponent>
);

AddPropertyFieldComponent("submit", SubmitButton);

export default SubmitButton;
